export const resourcesEn = {
  // English matches the msgstr already in locale/en/LC_MESSAGES/django.po.
  menuLabel: "Resources",
  favorites: {
    expert: "My favorite experts",
    tool: "My favorite tools",
    financialAid: "My favorite financial aid",
  },
  browse: {
    expert: "Experts",
    tool: "Tools",
    financialAid: "Financial aid",
  },
  // One string for all three, as templates/repertoire/_panel_content.html
  // renders a single msgid regardless of which directory the panel shows.
  openFullDirectory: "Open full directory",
};
